module.exports = __webpack_public_path__ + "f96c6a5db440e0b9416c0e8356b059de.fbx";